import Skeleton from '@mui/material/Skeleton';
import { pxToRem } from 'src/common/utils/fonts';

const rowSkeletonStyle = {
  borderRadius: pxToRem(8),
};

export const HeaderSkeleton = () => (
  <Skeleton variant="rectangular" sx={rowSkeletonStyle} animation="wave" height="0.75rem" />
);
